<div class="form-container">

  <div class="subform-container">
    <div class="title-text">{{getString('changePasswordText')}}</div> 
    <div class="form-field">
      <app-input-field [type]="'password'" [placeholder]="getString('password')" [autocomplete]="'new-password'" [name]="'password'" (valueChanged)="onPasswordChange($event)"></app-input-field>
    </div>

    <div class="form-field">
      <app-input-field [type]="'password'" [placeholder]="getString('confirmPassword')" [autocomplete]="'new-password'" [name]="'password-confirm'" (valueChanged)="onConfirmPasswordChange($event)"></app-input-field>
    </div>

    <div class="form-field">
      <button type="button" class="blue-button" (click)="changePassword()">{{getString('change')}}</button>
      <button type="button" (click)="close.emit()">{{getString('cancel')}}</button>
    </div>

    <div class="message-container">
        <div class="red-text" *ngIf="invalidPassword">{{getString('invalidPassword')}}</div>
        <div class="green-text" *ngIf="passwordChangeSuccess">
          {{getString('success')}}!
          <div><button (click)="close.emit()">{{getString('ok')}}</button></div>
        </div>
    </div>
  </div>

</div>